var _path, _path2, _rect, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOfficeAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 61,
    viewBox: "0 0 53 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.6299 28.457C42.6299 35.6942 37.69 41.7936 30.9542 43.6541C29.5787 44.034 28.1284 44.2372 26.6299 44.2372C25.1314 44.2372 23.681 44.034 22.3056 43.6541C15.5698 41.7936 10.6299 35.6942 10.6299 28.457C10.6299 19.7418 17.7933 12.6768 26.6299 12.6768C35.4664 12.6768 42.6299 19.7418 42.6299 28.457Z",
    fill: "#E82327"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9542 43.6541C29.5787 44.034 28.1284 44.2372 26.6299 44.2372C25.1314 44.2372 23.681 44.034 22.3056 43.6541L26.2936 48.5184C26.4667 48.7295 26.7931 48.7295 26.9661 48.5184L30.9542 43.6541Z",
    fill: "#E82327"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13.6299,
    y: 15.2769,
    width: 26,
    height: 26,
    rx: 13,
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2808 22.0496H23.9784C23.7601 22.0496 23.5801 22.2274 23.5801 22.4479V24.4915H24.3745V22.844H28.8825V24.4892H29.6769V22.4479C29.6792 22.2296 29.4991 22.0496 29.2808 22.0496Z",
    fill: "#515E6D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8315 24.6422V34.142C33.8315 34.3401 33.6695 34.5044 33.4692 34.5044H19.7901C19.5898 34.5044 19.4277 34.3401 19.4277 34.142V24.6422C19.4277 24.4442 19.5898 24.2799 19.7901 24.2799H33.4714C33.6695 24.2822 33.8315 24.4442 33.8315 24.6422Z",
    fill: "#B47B52"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8315 24.6422V27.5073H19.4277V24.6422C19.4277 24.4442 19.5898 24.2799 19.7901 24.2799H33.4714C33.6695 24.2822 33.8315 24.4442 33.8315 24.6422Z",
    fill: "#8E5C3D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.953 28.286H25.3063C25.2185 28.286 25.1442 28.2139 25.1442 28.1239V26.8906C25.1442 26.8028 25.2163 26.7285 25.3063 26.7285H27.953C28.0408 26.7285 28.115 26.8006 28.115 26.8906V28.1239C28.115 28.2139 28.043 28.286 27.953 28.286Z",
    fill: "#515E6D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3287 18.1209C42.3287 16.0806 40.6747 14.4267 38.6345 14.4267C36.5942 14.4267 34.9402 16.0806 34.9402 18.1209C34.9402 20.1612 36.5942 21.8151 38.6345 21.8151C40.6747 21.8151 42.3287 20.1612 42.3287 18.1209Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.6055 23.6768C41.6431 23.6768 44.1055 21.2144 44.1055 18.1768C44.1055 15.1391 41.6431 12.6768 38.6055 12.6768C35.5678 12.6768 33.1055 15.1391 33.1055 18.1768C33.1055 21.2144 35.5678 23.6768 38.6055 23.6768ZM40.5503 16.232C40.6535 16.1288 40.7936 16.0709 40.9395 16.0711C41.0855 16.0712 41.2254 16.1292 41.3285 16.2325C41.4316 16.3358 41.4895 16.4758 41.4894 16.6217C41.4893 16.7677 41.4312 16.9076 41.328 17.0108L38.2166 20.1221C38.1657 20.1734 38.1051 20.214 38.0383 20.2418C37.9716 20.2695 37.9 20.2838 37.8278 20.2838C37.7555 20.2838 37.6839 20.2695 37.6172 20.2418C37.5505 20.214 37.4899 20.1734 37.4389 20.1221L35.883 18.5662C35.8304 18.5154 35.7885 18.4547 35.7597 18.3876C35.7309 18.3205 35.7157 18.2484 35.7151 18.1753C35.7144 18.1023 35.7284 18.0299 35.756 17.9623C35.7837 17.8947 35.8245 17.8333 35.8762 17.7816C35.9278 17.73 35.9892 17.6892 36.0568 17.6615C36.1244 17.6339 36.1968 17.6199 36.2698 17.6206C36.3429 17.6212 36.415 17.6364 36.4821 17.6652C36.5492 17.694 36.6099 17.7359 36.6607 17.7885L37.8278 18.955L40.5503 16.2325V16.232Z",
    fill: "#2FC365"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfficeAdd);
export default __webpack_public_path__ + "static/media/OfficeAdd.c23b87121cc58499377bd83d7d67d36e.svg";
export { ForwardRef as ReactComponent };